var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1em","height":"1em","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M3 21v-2h18v2Zm0-4V7h18v10Zm2-2h14V9H5ZM3 5V3h18v2Zm2 10V9v6Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }